import React from 'react';
import Header from '../header/Header'
import { Link } from 'react-router-dom'
export default ({ site }) => {

    const getUserInfo = t => {
        let user = site.users.filter(d => d.roleType === t)
        if (user.length > 0) return <a href={`mailto:${user[0]['emailId']}`} > {user[0]['employeeName']} <i title="Click here to send email" className="fas fa-envelope primary-clr"></i></a>
        else return 'NA';
    }
    
    return (
        <>
            <Header />
            <div className="error-container">
            <div style={{ fontSize: 'x-large' }}>
                    You do not have access to this site ({site.siteName}), Please contact site Owner/Alternate  for access.
            </div>
            </div><br /><br />
            <div style={{ fontSize: 'large', textAlign: 'center' }} className="owner-info">
                <label>Owner: </label> <span>{getUserInfo('Owner')}</span> <br />
                <label>Alternate: </label>  <span>{getUserInfo('Alternate')}</span> <br />
                <span><Link to="/">Click here</Link> to go to Home page. <br /></span>
            </div>
        </>
    )
}
